<button mat-icon-button color="primary" matTooltip="{{'COMMON_LIST.ACTIONS.VIEW' | translate}}"
    matTooltipPosition="above" (click)="actionClick('view')">
    <mat-icon class="mx-8">visibility</mat-icon>
</button>

<button mat-icon-button color="primary" matTooltip="{{'ALERTS.EDIT' | translate}}"
    matTooltipPosition="above" (click)="actionClick('edit')" *ngIf="sourceId == 4 && canBeEdited && alertStatus !=='Rejected'">
    <mat-icon class="mx-8">arrow_forward</mat-icon>
</button>

<button mat-icon-button color="primary" matTooltip="{{'COMMON_LIST.ACTIONS.UPDATE' | translate}}"
    matTooltipPosition="above" (click)="actionClick('update')">
    <mat-icon class="mx-8">sync</mat-icon>
</button>

<!--@Tom: REOPEN BUTTON FOR FUTURE DEVELOPMENT-->
<!-- @Tom - TODO: develop reOpen button -->
<!-- <button mat-icon-button color="primary" matTooltip="{{'COMMON_LIST.ACTIONS.RE-OPEN' | translate}}"
    matTooltipPosition="above" (click)="actionClick('reOpen')">
    <mat-icon class="mx-8">lock_open</mat-icon>
</button> -->

<button mat-icon-button color="primary" matTooltip="{{'COMMON_LIST.ACTIONS.DELETE' | translate}}"
    matTooltipPosition="above" (click)="actionClick('deleteItem')" *ngIf="deleteButton">
    <mat-icon class="mx-8">delete_outline</mat-icon>
</button>

<button mat-icon-button color="primary" matTooltip="{{'COMMON_LIST.ACTIONS.COMPLETE' | translate}}"
    matTooltipPosition="above" (click)="actionClick('completeItem')" *ngIf="alertStatus !=='Closed' && alertStatus !=='Rejected' && canCompleted">
    <mat-icon class="mx-8">check</mat-icon>
</button>